(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-quote"] && !Shopify.designMode) return;
  try {
    
  class PhotoQuote extends HTMLElement {
    // Long side of the photo sent for analysis; bigger adds cost, not accuracy.
    static MAX_SIDE = 1568;
    static TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

    /** Today's date in the visitor's time zone, as YYYY-MM-DD. */
    static today() {
      const now = new Date();
      return new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    }

    connectedCallback() {
      this.tokenWaiters = [];
      this.endpoint = this.dataset.endpoint.replace(/\/$/, '');
      // `t` escapes apostrophes (couldn&#39;t) and the strings go into textContent,
      // so turn the entities back into characters.
      const decode = (v) =>
        typeof v === 'string'
          ? new DOMParser().parseFromString(v, 'text/html').documentElement.textContent
          : Object.fromEntries(Object.entries(v).map(([k, x]) => [k, decode(x)]));
      this.t = decode(JSON.parse(this.querySelector('[data-strings]').textContent));
      this.fileInput = this.querySelector('[data-file]');
      this.preview = this.querySelector('[data-preview]');
      this.submit = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.result = this.querySelector('[data-result]');
      this.form = this.querySelector('[data-upload-form]');

      // No delivery dates in the past (local date, same as the server's Miami check).
      // iPhone Safari's picker ignores `min`, so a past pick snaps back to today.
      this.dateInput = this.form.querySelector('input[name="date"]');
      this.dateInput.min = PhotoQuote.today();
      this.dateInput.addEventListener('change', () => {
        this.dateInput.min = PhotoQuote.today();
        if (this.dateInput.value && this.dateInput.value < this.dateInput.min) {
          this.dateInput.value = this.dateInput.min;
          this.status.textContent = this.t.errors.bad_date;
        }
      });

      this.terms = this.querySelector('[data-terms]');
      this.terms.addEventListener('change', () => this.updateSubmit());
      const termsToggle = this.querySelector('[data-terms-toggle]');
      termsToggle.addEventListener('click', () => {
        const text = this.querySelector('[data-terms-text]');
        text.hidden = !text.hidden;
        termsToggle.setAttribute('aria-expanded', String(!text.hidden));
      });
      this.fileInput.addEventListener('change', () => this.pick(this.fileInput.files[0]));
      // Drop a "fill in all fields" message once the customer starts fixing it.
      this.form.addEventListener('input', () => {
        if ([this.t.errors.missing_fields, this.t.errors.bad_date].includes(this.status.textContent)) {
          this.status.textContent = '';
        }
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.requestQuote();
      });
      this.querySelector('[data-again]').addEventListener('click', () => this.reset());
      this.querySelector('[data-whatsapp]').addEventListener('click', () => this.track('whatsapp_click'));

      const drop = this.querySelector('[data-drop]');
      drop.addEventListener('dragover', (e) => {
        e.preventDefault();
        drop.classList.add('is-dragging');
      });
      drop.addEventListener('dragleave', () => drop.classList.remove('is-dragging'));
      drop.addEventListener('drop', (e) => {
        e.preventDefault();
        drop.classList.remove('is-dragging');
        if (e.dataTransfer.files[0]) this.pick(e.dataTransfer.files[0]);
      });
    }

    setState(state) {
      this.dataset.state = state;
    }

    // Funnel events for Shopify Customer events; a custom pixel forwards them
    // to GA4 (see the marisole-photo-quote README). No personal data here.
    track(name, data = {}) {
      try {
        window.Shopify?.analytics?.publish?.(`photo_quote_${name}`, data);
      } catch {}
    }

    // The button stays clickable so a missing photo or field gets explained.
    updateSubmit() {
      this.submit.disabled = this.dataset.state === 'loading';
    }

    async pick(file) {
      this.status.textContent = '';
      this.photo = null;
      this.submit.disabled = true;
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        this.status.textContent = this.t.errors.bad_type;
        return;
      }
      this.status.textContent = this.t.preparing;
      try {
        this.photo = await this.shrink(file);
      } catch {
        this.status.textContent = this.t.errors.bad_type;
        return;
      }
      if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
      this.previewUrl = URL.createObjectURL(this.photo);
      this.preview.src = this.previewUrl;
      this.preview.hidden = false;
      this.querySelector('[data-change]').hidden = false;
      this.querySelector('[data-drop-text]').hidden = true;
      this.track('photo_added');
      this.status.textContent = '';
      this.updateSubmit();
      this.startTurnstile();
    }

    // The quote service only answers requests carrying a fresh Turnstile token.
    // The script is loaded on the first photo, not with the page, and a token
    // is good for one request, so the widget is reset after each use.
    startTurnstile() {
      if (this.turnstileReady) return;
      this.turnstileReady = new Promise((resolve, reject) => {
        const render = () => {
          this.widgetId = window.turnstile.render(this.querySelector('[data-turnstile]'), {
            sitekey: this.dataset.sitekey,
            action: 'turnstile-spin-v2',
            appearance: 'interaction-only',
            theme: 'light',
            callback: (token) => {
              const waiting = this.tokenWaiters.splice(0);
              if (waiting.length) waiting.forEach((resolve) => resolve(token));
              else this.token = token;
            },
            'expired-callback': () => (this.token = null),
            'error-callback': () => (this.token = null),
          });
          resolve();
        };
        if (window.turnstile) return render();
        const script = document.createElement('script');
        script.src = PhotoQuote.TURNSTILE_SRC;
        script.async = true;
        script.onload = render;
        script.onerror = () => reject(new Error('captcha_failed'));
        document.head.append(script);
      });
    }

    async getToken() {
      this.startTurnstile();
      await this.turnstileReady;
      if (this.token) return this.token;
      // Most visitors pass silently; the rare one asked to tick the box sees why we wait.
      this.status.textContent = this.t.verify;
      return new Promise((resolve, reject) => {
        this.tokenWaiters.push(resolve);
        setTimeout(() => reject(new Error('captcha_failed')), 30000);
      });
    }

    spendToken() {
      this.token = null;
      if (this.widgetId !== undefined) window.turnstile.reset(this.widgetId);
    }

    // Re-encode as a JPEG no larger than MAX_SIDE. Also turns HEIC from
    // iPhones into something the server accepts, where the browser can decode it.
    async shrink(file) {
      const bitmap = await createImageBitmap(file);
      const scale = Math.min(1, PhotoQuote.MAX_SIDE / Math.max(bitmap.width, bitmap.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(bitmap.width * scale);
      canvas.height = Math.round(bitmap.height * scale);
      canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      bitmap.close?.();
      return new Promise((resolve, reject) =>
        canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('encode'))), 'image/jpeg', 0.85)
      );
    }

    // One step: the photo and the delivery details go out together, so every
    // quote reaches the florist as a complete request.
    async requestQuote() {
      if (!this.photo) {
        this.status.textContent = this.t.errors.no_photo;
        this.querySelector('[data-drop]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        this.status.textContent = this.dateInput.validity.rangeUnderflow
          ? this.t.errors.bad_date
          : this.t.errors.missing_fields;
        return;
      }
      if (!this.terms.checked) {
        this.status.textContent = this.t.errors.terms_required;
        return;
      }
      this.setState('loading');
      this.submit.disabled = true;
      this.status.textContent = this.t.analyzing;
      this.track('submitted');

      try {
        const body = new FormData(this.form);
        body.set('photo', this.photo, 'bouquet.jpg');
        // The summary and the customer's email come back in the page language.
        body.set('locale', this.dataset.locale || 'en');
        body.append('cf-turnstile-response', await this.getToken());
        this.spendToken();
        this.status.textContent = this.t.analyzing;
        const res = await fetch(`${this.endpoint}/quote`, { method: 'POST', body });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || 'generic');
        this.quote = data;
        this.render(data);
        this.setState('result');
        this.status.textContent = '';
        this.track('result', {
          estimate_low: data.low,
          estimate_high: data.high,
          value: Math.round((data.low + data.high) / 2),
          currency: 'USD',
          format: data.format,
          size: data.size,
          delivery_status: data.delivery?.status || 'unknown',
          matches: data.matches.length,
          lead_sent: data.leadSent !== false,
        });
      } catch (e) {
        this.track(['not_flowers', 'inappropriate'].includes(e.message) ? 'rejected' : 'error', { reason: e.message });
        this.setState('idle');
        this.updateSubmit();
        this.status.textContent = this.t.errors[e.message] || this.t.errors.generic;
        // A rejected photo won't pass on retry: put the upload prompt back.
        if (['not_flowers', 'inappropriate', 'bad_type', 'too_large'].includes(e.message)) this.clearPhoto();
      }
    }

    clearPhoto() {
      this.photo = null;
      this.fileInput.value = '';
      this.preview.hidden = true;
      this.querySelector('[data-change]').hidden = true;
      this.querySelector('[data-drop-text]').hidden = false;
      this.updateSubmit();
    }

    money(n) {
      return '$' + Math.round(n).toLocaleString('en-US');
    }

    render(q) {
      this.querySelector('[data-sent-text]').textContent = q.leadSent === false ? this.t.lead_failed : this.t.lead_sent;
      const availability = this.querySelector('[data-availability]');
      availability.textContent = q.availabilityNote || '';
      availability.hidden = !q.availabilityNote;
      this.querySelector('[data-delivery]').textContent = this.deliveryText(q.delivery);
      const whatsapp = this.querySelector('[data-whatsapp]');
      const base = whatsapp.href.split('?')[0];
      whatsapp.href = `${base}?text=${encodeURIComponent(this.t.whatsapp_text.replace('{id}', q.quoteId.slice(0, 8)))}`;
      this.querySelector('[data-price]').textContent = `${this.money(q.low)} – ${this.money(q.high)}`;
      this.querySelector('[data-summary]').textContent = q.summary;

      const flowers = this.querySelector('[data-flowers]');
      flowers.replaceChildren(
        ...q.flowers.map((f) => {
          const li = document.createElement('li');
          li.textContent = `~${f.count} ${this.t.flowers[f.type] || f.type.replace(/_/g, ' ')}`;
          return li;
        })
      );

      const wrap = this.querySelector('[data-matches-wrap]');
      const list = this.querySelector('[data-matches]');
      list.replaceChildren(...q.matches.map((m) => this.card(m)));
      wrap.hidden = q.matches.length === 0;

      this.result.hidden = false;
      this.querySelector('[data-upload-form]').hidden = true;
      this.result.focus({ preventScroll: true });
      this.result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Same wording as the customer's email; the worker estimates the fee from
    // the ZIP code with the store's delivery bands.
    deliveryText(d) {
      const price = (n) => '$' + Number(n).toFixed(2).replace(/\.00$/, '');
      if (!d || !this.t.delivery[d.status]) return this.t.delivery.unknown;
      return this.t.delivery[d.status].replace('{fee}', price(d.fee)).replace('{free_from}', price(d.freeFrom));
    }

    card(m) {
      const li = document.createElement('li');
      li.className = 'photo-quote__card';
      const a = document.createElement('a');
      a.href = m.url;
      a.className = 'photo-quote__card-link';
      a.addEventListener('click', () => this.track('similar_click', { product: m.title, price: m.price, tier: m.tier }));

      const img = document.createElement('img');
      img.src = m.image + (m.image.includes('?') ? '&' : '?') + 'width=500';
      img.alt = ''; // the link text below already names the product
      img.loading = 'lazy';
      img.width = 500;
      img.height = 625;

      const tier = document.createElement('span');
      tier.className = `photo-quote__tier photo-quote__tier--${m.tier}`;
      tier.textContent = this.t[`tier_${m.tier}`] || '';

      const title = document.createElement('span');
      title.className = 'photo-quote__card-title';
      title.textContent = m.title;

      const price = document.createElement('span');
      price.className = 'photo-quote__card-price';
      // Size variants are often a bare stem count ("25"); say what the number is.
      const size = /^\d+$/.test(m.variantTitle || '') ? `${m.variantTitle} ${this.t.stems}` : m.variantTitle;
      price.textContent = this.money(m.price) + (size ? ` · ${size}` : '');

      a.append(img, tier, title, price);
      li.append(a);
      return li;
    }

    reset() {
      this.quote = null;
      this.clearPhoto();
      this.result.hidden = true;
      this.querySelector('[data-upload-form]').hidden = false;
      this.status.textContent = '';
      this.setState('idle');
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  if (!customElements.get('photo-quote')) customElements.define('photo-quote', PhotoQuote);

  } catch(e) { console.error(e); }
})();
})();
